import { apiFetch } from './api';
import type { ApiUser } from './auth';

export const getSession = () =>
  apiFetch<{ user: ApiUser | null }>(`/session`);
